import * as prettyjson from 'prettyjson';
import {DisplayerContract} from 'common/tool/DisplayerContract';
import {Logger} from 'common/tool/Logger';

export class Displayer implements DisplayerContract {
    public error(error: Error): void {
        Logger.error(error);
    }

    public info(message: string): void {
        Logger.trace(message);
    }

    public json(json: any): void {
        Logger.trace(prettyjson.render(json, {}));
    }

    public success(message: string): void {
        Logger.trace(message);
    }
}
